/**
 * useTourStore — state machine cho tour Hướng dẫn dùng dự án.
 *
 * Flow:
 *  idle → click ? trên ProjectsList
 *  → 'create-button' (highlight nút "Dự án mới")
 *  → user click → 'create-modal' (modal mở, name prefill)
 *  → user confirm → 'select-demo' (modal close, list filter chỉ hiện demo + arrow nhấp nháy)
 *  → user click demo → 'in-detail' (vào project detail, Stage4ProjectTour fire)
 *  → tour close → idle
 */

import { create } from 'zustand';

export type TourStep = 'idle' | 'create-button' | 'create-modal' | 'select-demo' | 'in-detail';

interface TourState {
    step: TourStep;
    isActive: () => boolean;
    start: () => void;
    advance: (next: TourStep) => void;
    end: () => void;
}

export const useTourStore = create<TourState>((set, get) => ({
    step: 'idle',
    isActive: () => get().step !== 'idle',
    start: () => set({ step: 'create-button' }),
    advance: (next) => set({ step: next }),
    end: () => set({ step: 'idle' }),
}));
